import {
  TBaseBulkDeleteResponseDto,
  TBaseCreateResponseDto,
  TBaseDeleteResponseDto, TBaseGetAllResponseDto, TBaseGetResponseDto, TBaseUpdateResponseDto
} from './common/t-base-response.dto';
import {AutoMap} from '@automapper/classes';
import {
  TBaseBulkDeleteRequestDto,
  TBaseCreateRequestDto, TBaseDeleteRequestDto,
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseUpdateRequestDto
} from './common/t-base-request.dto';

export class UserGetAllRequestDto extends TBaseGetAllRequestDto {}
export class UserGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  firstName!: string;
  @AutoMap()
  lastName!: string | null;
  @AutoMap()
  email!: string;
}

export class UserGetRequestDto extends TBaseGetRequestDto {}
export class UserGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  firstName!: string;
  @AutoMap()
  lastName!: string;
  @AutoMap()
  email!: string;
}

export class UserCreateRequestDto extends TBaseCreateRequestDto {
  @AutoMap()
  firstName!: string;
  @AutoMap()
  lastName!: string | null;
  @AutoMap()
  email!: string;
  @AutoMap()
  passwordHash!: string;
}
export class UserCreateResponseDto extends TBaseCreateResponseDto {}

export class UserUpdateRequestDto extends TBaseUpdateRequestDto {
  @AutoMap()
  firstName!: string;
  @AutoMap()
  lastName!: string;
  @AutoMap()
  email!: string;
}
export class UserUpdateResponseDto extends TBaseUpdateResponseDto {}

export class UserDeleteRequestDto extends TBaseDeleteRequestDto {}
export class UserDeleteResponseDto extends TBaseDeleteResponseDto {}

export class UserBulkDeleteRequestDto extends TBaseBulkDeleteRequestDto {}
export class UserBulkDeleteResponseDto extends TBaseBulkDeleteResponseDto {}
